module.exports = __webpack_public_path__ + "static/img/200042.c8b862c8.png";